import { Divider, NonIdealState } from '@blueprintjs/core';
import noBanksSVG from '../../../assets/noBanks.svg';
import { BankNotesCardView } from './BankNotesCardView.tsx';
import panelClasses from '../Panel/Panel.module.css';
import { CommunicationCount } from '../Panel';
import { useBankNotes, useLenders } from '@axo/shared/data-access/hooks';

interface IBankNotesPanel {
  marketCountry: string;
  applicationID: string;
}

export function BankNotesPanel({
  marketCountry,
  applicationID,
}: IBankNotesPanel) {
  const bankNotes = useBankNotes(applicationID, marketCountry);
  const lenders = useLenders(marketCountry);

  return (
    <div className={panelClasses.panel}>
      <CommunicationCount
        label="Number of bank notes in total:"
        count={bankNotes.data?.Items?.length || 0}
      />
      <Divider />
      <div className={panelClasses.cardContainer}>
        {!bankNotes.isSuccess ? (
          <NonIdealState>
            <p>Loading bank notes...</p>
          </NonIdealState>
        ) : null}

        {bankNotes.isSuccess && !bankNotes.data.Items?.length ? (
          <NonIdealState icon={<img src={noBanksSVG} alt="No bank notes" />}>
            <p>There are no bank notes added yet.</p>
          </NonIdealState>
        ) : null}

        {bankNotes.data?.Items?.map((bankNote) => (
          <BankNotesCardView
            key={bankNote.ID}
            bankNote={bankNote}
            lenderShortName={
              lenders.data?.find((x) => x.ID === bankNote.LenderID)?.ShortName
            }
            lenderName={
              lenders.data?.find((x) => x.ID === bankNote.LenderID)?.Name
            }
          />
        ))}
      </div>
    </div>
  );
}
